import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that scrolls to the top of the page when the pathname changes
 * or handles scrolling to an element if a hash is present in the URL.
 */
const useScrollTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash in the URL (like #mission), scroll to that element
    if (hash) {
      // Remove the # character
      const elementId = hash.substring(1);
      
      // Add a slight delay to ensure the component is mounted
      setTimeout(() => {
        const element = document.getElementById(elementId);
        
        if (element) {
          const headerOffset = 100; // Account for fixed header
          const elementTop = element.getBoundingClientRect().top;
          const offsetPosition = elementTop + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // If no hash, scroll to top of the page
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto' // Use 'smooth' for smooth scrolling, 'auto' for immediate
      });
    }
  }, [pathname, hash]);
};

export default useScrollTop;